import { Grid, Box, Typography } from '@mui/material';
import React from 'react';
import {
  NumberField, useRecordContext, TextField,
} from 'react-admin';

const RuleScore = () => {
  const record = useRecordContext();
  const period = record?.riskTimeline?.period;
  const amount = record?.riskTimeline?.amount;
  const timeline = amount !== undefined && period ? `${amount} ${period}` : undefined;

  return (
    <Grid container spacing={6}>
      <Grid size={12}>
        <Box display="flex" flexDirection="column">
          <Typography variant="label" color="black" fontWeight="bold">Rule score</Typography>
          <NumberField source="score" emptyText="0" />
          <Typography variant="caption" color="text.secondary">
            Rule scores can no longer be changed. To raise risk, assign a group with a score.
          </Typography>
        </Box>
      </Grid>
      <Grid size={12}>
        <Box display="flex" flexDirection="column">
          <Typography variant="label" color="black" fontWeight="bold">Risk decreasing timeline</Typography>
          <TextField record={{ timeline }} source="timeline" emptyText="-" />
        </Box>
      </Grid>
    </Grid>
  );
};

export default RuleScore;
